import { LocalTypes } from '../types/CustomJobAd';

export default {
    namespaced: true,
    state: {
        title: null,
        fulltext: null,
    },
    getters: {},
    actions: {},
    mutations: {
        [LocalTypes.mutations.SET_JOB_AD]: (state, { title, fulltext }) => {
            state.title = title;
            state.fulltext = fulltext;
        },
    },
};
